import {
  ROOT,
  BOOKING_GET_ALL,
  DASHBOARD_REVENUE_STATUS,
  DASHBOARD_BOOKING_STATUS,
  DASHBOARD_HOTEL_STATUS,
  DASHBOARD_CONFIRM_HOTEL_INFO,
  DASHBOARD_INFO_STATUS,
  GET_PROSESS_DASHBOARD,
  UPDATE_PROSESS_DASHBOARD,
  IGRONE_PROSESS_DASHBOARD
} from '@/_helpers/constant.js';
import { requestOptions, handleResponse } from '@/_helpers';

function getRevenueStatus() {
  return fetch(ROOT + DASHBOARD_REVENUE_STATUS, requestOptions.get())
    .then(handleResponse);
}

function getBookingStatus() {
  return fetch(ROOT + DASHBOARD_BOOKING_STATUS, requestOptions.get())
    .then(handleResponse);
}

function getHotelStatus() {
  return fetch(ROOT + DASHBOARD_HOTEL_STATUS, requestOptions.get())
    .then(handleResponse);
}

function confirmHotelInfo() {
  return fetch(ROOT + DASHBOARD_CONFIRM_HOTEL_INFO, requestOptions.get())
    .then(handleResponse);
}

function getInfoStatus() {
  return fetch(ROOT + DASHBOARD_INFO_STATUS, requestOptions.get())
    .then(handleResponse);
}

function getAllBooking(params) {
  return fetch(ROOT + BOOKING_GET_ALL, requestOptions.post(params))
    .then(handleResponse);
}

function getProcess() {
  return fetch(ROOT + GET_PROSESS_DASHBOARD, requestOptions.get())
    .then(handleResponse);
}

function updateProcess(data) {
  return fetch(ROOT + UPDATE_PROSESS_DASHBOARD + `/${data}`, requestOptions.post())
    .then(handleResponse);
}

function updateIgrone(data) {
  return fetch(ROOT + IGRONE_PROSESS_DASHBOARD + `/${data}`, requestOptions.post())
    .then(handleResponse);
}

export const service = {
  getAllBooking,
  getRevenueStatus,
  getBookingStatus,
  getHotelStatus,
  confirmHotelInfo,
  getInfoStatus,
  getProcess,
  updateProcess,
  updateIgrone
};